<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    @click="$emit('click')"
  >
    <path
      d="M3,3A2,2 0 0,0 1,5V19A2,2 0 0,0 3,21H21A2,2 0 0,0 23,19V5A2,2 0 0,0 21,3H3M3,5H13V9H21V19H3V5M10,10V13H7V15H10V18H12V15H15V13H12V10H10Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "TabPlusIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
